<template>
  <input class="base-input" v-model="localModel" :type="type" v-on="$listeners" />
</template>

<script>
export default {
  name: 'BaseInput',
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: { type: [String, Number, Array, Object], default: '' },
    type: { type: String, default: 'text' }
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  }
}
</script>

<style>
.base-input {
  background: #FFFFFF;
  border: 1px solid #CCD4E0;
  box-sizing: border-box;
  border-radius: 5px;
  height: 35px;
  width: 200px;
  padding-left: 15px;
  color: #9F9F9F;
  font-size: 14px;
}

.base-input:focus, .base-input:active {
  border-color: #2EA3FF;
  outline: unset;
}
</style>
